import script from "./EventView.vue?vue&type=script&setup=true&lang=js"
export * from "./EventView.vue?vue&type=script&setup=true&lang=js"

import "./EventView.vue?vue&type=style&index=0&id=45e6d1d6&scoped=true&lang=css"

import exportComponent from "/Volumes/SSD/jenkins/workspace/Walk Online Mobile/Walk Online Admin/Walk Online Admin Prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45e6d1d6"]])

export default __exports__